import styles from "../../../shared/components/shell.module.css";

export type TeacherRow = { id: string; display_name: string; role: string };

/**
 * The teachers of this school.
 *
 * The note is not decoration: a head teacher sees the structure but not the
 * results of individual children, and knowing that is part of what is being
 * promised to parents.
 */
export function TeacherTable({ teachers }: { teachers: readonly TeacherRow[] }) {
  return (
    <div className={`${styles.card} ${styles.spaced}`}>
      <h2 className={styles.title} style={{ fontSize: "1.15rem" }}>
        Lehrkräfte
      </h2>
      <p className={styles.subtitle}>
        Sie sehen die Lehrkräfte Ihrer Schule und deren Klassen – aber nicht die
        Ergebnisse einzelner Kinder. Die sieht nur, wer die Klasse unterrichtet.
      </p>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Rolle</th>
          </tr>
        </thead>
        <tbody>
          {teachers.map((person) => (
            <tr key={person.id}>
              <td>{person.display_name}</td>
              <td>{person.role === "school_admin" ? "Schulleitung" : "Lehrkraft"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
